module.exports = __webpack_public_path__ + "img/brickwall_thumb.7429e4ed.jpg";